import { createCalendarGroup as createCalendarGroupAction } from 'owa-calendar-update';
import { createCalendarGroup } from '../actions/calendarGroupActions';
import { orchestrator } from 'satcheljs';
import { stoppedCreatingCalendarGroup } from '../mutators/creatingCalendarGroupMutators';

orchestrator(createCalendarGroup, actionMessage => {
    stoppedCreatingCalendarGroup(actionMessage.scenarioId);

    // create a new calendar group. updates store, which will update computed groupCalendars and rerender this component
    createCalendarGroupAction(actionMessage.userIdentity, actionMessage.calendarGroupName);
});
